import { FlyoutService } from './flyout.service';

export const Services = [
	FlyoutService,
];
